/** Roles that may create, alter, transmit, cancel, or renew prescriptions. */
export const PRESCRIBING_ROLES = [
  "provider",
  "physician",
  "org_admin",
  "super_admin",
] as const;

export function canPrescribe(role: string | null | undefined): boolean {
  return PRESCRIBING_ROLES.includes(role as (typeof PRESCRIBING_ROLES)[number]);
}
